export const NAV_HEIGHT = 'NAV_HEIGHT'
export const TICKET_TYPES = 'TICKET_TYPES'
export const TICKET_TYPE = 'TICKET_TYPE'
export const TICKET_GROUP = 'TICKET_GROUP'
export const TICKET_MEMBERS = 'TICKET_MEMBERS'
export const USER_TOKEN = 'USER_TOKEN'
export const USER_INFO = 'USER_INFO'
export const USER_REGISTERES = 'USER_REGISTERES'
export const USER_PAYMENT = 'USER_PAYMENT'
export const USER_SEATS = 'USER_SEATS'
export const BOOKING_AREA = 'BOOKING_AREA'
export const BOOKING_SEATS = 'BOOKING_SEATS'
export const BOOKING_SELECTED_AREA = 'BOOKING_SELECTED_AREA'
export const FORGAMERS_NEWS = 'FORGAMERS_NEWS'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js